import type { RouteObject } from 'react-router';

import { NotFoundPage } from './404/NotFound';
import { notFoundRoute } from './404/404.route';
import { serverErrorRoute } from './500/500.route';

/**
 * The three route objects the system pair contributes, aggregated so the router
 * pulls the feature in on one line. Multiple `RouteObject`s from one file, so
 * the name is `.routes.tsx` plural.
 *
 * The catch-all renders the not-found surface **at the URL that failed** rather
 * than redirecting to `/404`. A redirect would replace the address the operator
 * was reading with one they never typed, so the two things they might do next —
 * read the URL back to a colleague, or correct a typo in it — both stop working.
 * The named route stays as well, because the sitemap carries it and a surface
 * with no address of its own cannot be linked, tested, or reported against.
 *
 * The splat is the lowest-ranked pattern the router holds, so it is only reached
 * once every real route has failed to match — including the ones that land after
 * this feature does.
 */
export const systemRoutes: RouteObject[] = [
  notFoundRoute,
  serverErrorRoute,
  { path: '*', element: <NotFoundPage /> },
];
